export default __webpack_public_path__ + "media/1f6894e139936806f5ca8ccbfd35cbca66138ac803d4d7a77100da28dd970ff4.svg";